import { ObjectStore } from '@softline/core';
import { Kunde } from '../types/kunde';

export const FormStore = ObjectStore.create<Kunde>();
